export default "__VITE_ASSET__C8y1SPiC__"